import { render } from "./ProductLink.vue?vue&type=template&id=b33d0a80&scoped=true"
import script from "./ProductLink.vue?vue&type=script&lang=js"
export * from "./ProductLink.vue?vue&type=script&lang=js"

import "./ProductLink.vue?vue&type=style&index=0&id=b33d0a80&lang=scss&scoped=true"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b33d0a80"]])

export default __exports__